// extracted by mini-css-extract-plugin
export default {"HtmlItemDialog":"h5HIE5LOsmCpdoO0JR1eIw==","htmlVarsButton":"xiXST8psZu2wHGsWtT5c3w=="};